import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccessControlGateDto } from '@shared/src/dtos/accesscontrol/gate/AccessControlGateDto';
import { ForkliftDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';

@Component({
    selector: 'shared-forklift-left',
    templateUrl: './shared.forklift.left.component.html',
    styleUrls: ['./shared.forklift.left.component.scss']
})
export class SharedForkliftLeftComponent implements OnChanges {

    @Input() public value: ForkliftDto;
    @Input() public open: boolean = false;
    @Input() public selectedGateId: string = '';
    @Output() public clickGateOption = new EventEmitter<OptionDto>();
    @Output() public clickRoute = new EventEmitter<AccessControlGatePlateDto>();

    public gateOptions: OptionsStripDto;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['value'] || changes['selectedGateId']) {
            this.buildGateOptions();
        }
    }

    private buildGateOptions() {
        const gates: AccessControlGateDto[] = this.value?.accessControlDTO?.accessControlGates ?? [];
        this.gateOptions = new OptionsStripDto();
        gates.forEach((gate, i) => {
            const selected = gate.gateId.toString() === this.selectedGateId;
            const option = OptionDto.build(gate.gateId.toString(), gate.gateName, '', '', (i + 1) * 10, -1, -1, selected, false);
            option.backColor = gate.backColor ?? null;
            option.foreColor = gate.foreColor ?? null;
            this.gateOptions.add(option);
        });
        OptionsStripDto.arrange(this.gateOptions, this.selectedGateId, '');
    }

    get gates(): AccessControlGateDto[] {
        return this.value?.accessControlDTO?.accessControlGates ?? [];
    }

    get selectedGatePlates(): AccessControlGatePlateDto[] {
        const gate = this.gates.find(g => g.gateId.toString() === this.selectedGateId);
        return gate?.plates ?? [];
    }
    get selectedGate(): AccessControlGateDto {
        const gate = this.gates.find(g => g.gateId.toString() === this.selectedGateId);
        return gate;
    }
    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
